import { DesignationActionDto } from "./designation-action.dto";
import { GlobalResponseObject } from "@gtpl/shared-models/common-models";

export class AllDesignationActionResponseModel extends GlobalResponseObject{
    data?: DesignationActionDto[];

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
     constructor(status:boolean, intlCode:number, internalMessage:string, data?: DesignationActionDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}